import * as React from 'react';
import { MediaInput, MediaInputProps } from '@dozuki/web-js/components';
import { useLocalization } from '~/framework';
import { useToast, BoxProps } from '@chakra-ui/react';

type MediaInputComponentProps = Omit<BoxProps, 'onChange'> & {
   initialValue?: MediaInputProps['value'] | null;
   fieldName: string;
   // Optional, included to be able to get image id and type within quizzes
   changeFn?: (ev: any) => void;
};

export function MediaInputComponent({
   filter,
   initialValue,
   fieldName,
   changeFn,
   ...props
}: MediaInputComponentProps) {
   const [value, setValue] = React.useState(initialValue !== null ? initialValue : null);
   const input = React.useRef<HTMLInputElement | null>(null);
   const { _js } = useLocalization();
   const toast = useToast();

   // Emit a change event so that legacy JS can detect change
   React.useEffect(() => {
      if (input.current) {
         input.current.dispatchEvent(new Event('change'));
      }
   }, [value?.id, value?.type]);

   return (
      <>
         <input
            ref={input}
            type="hidden"
            name={fieldName}
            id={fieldName}
            value={value ? value.id : undefined}
         />
         <MediaInput
            filter={filter as any}
            value={!value || value.id === 0 ? undefined : value}
            onChange={ev => {
               setValue(ev);
               if (changeFn) {
                  changeFn(ev);
               }
            }}
            _js={_js}
            className="mediaTarget"
            toast={toast}
            {...props}
         />
      </>
   );
}
